import React, { memo } from "react";
import { Box, Button, Grid, IconButton, MenuItem, Typography } from "@mui/material";
import IpdTextField from "../../../../utils/IpdTextField";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import FormField from "../FormField";
import ConfigurableField from "../ConfigurableField";
import { CONTACT_CHANNELS, CONTACT_TYPES } from "../../constants/registrationConstants";
import { CONFIGURED_SECTION_IDS } from "../../utils/sectionConfiguration";
import { useSectionConfig } from "../../context/SectionConfigContext";

const S = CONFIGURED_SECTION_IDS;

function Contacts({ patient, updateListItem, addListItem, removeListItem, errors = {} }) {
  const { canAddListEntry, canRemoveListEntry, config, getListFieldGridSize } = useSectionConfig();
  const md = config ? getListFieldGridSize(S.contacts) : 2;

  return (
    <Box>
      {errors.contacts__min && (
        <Typography variant="caption" color="error" sx={{ display: "block", mb: 1 }}>
          {errors.contacts__min}
        </Typography>
      )}
      {patient.contacts.map((c, i) => (
        <Grid container spacing={1} key={i} alignItems="center" sx={{ mb: 1 }}>
          <ConfigurableField sectionId={S.contacts} fieldName="channel" xs={12} sm={3} md={md}>
            {({ required }) => (
              <FormField label="Channel" required={required} error={errors[`contacts.${i}.channel`]}>
                <IpdTextField select fullWidth size="small" value={c.channel} onChange={(e) => updateListItem("contacts", i, "channel", e.target.value)}>
                  {CONTACT_CHANNELS.map((x) => <MenuItem key={x} value={x}>{x}</MenuItem>)}
                </IpdTextField>
              </FormField>
            )}
          </ConfigurableField>
          <ConfigurableField sectionId={S.contacts} fieldName="type" xs={12} sm={3} md={md}>
            {({ required }) => (
              <FormField label="Type" required={required} error={errors[`contacts.${i}.type`]}>
                <IpdTextField select fullWidth size="small" value={c.type} onChange={(e) => updateListItem("contacts", i, "type", e.target.value)}>
                  {CONTACT_TYPES.map((x) => <MenuItem key={x} value={x}>{x}</MenuItem>)}
                </IpdTextField>
              </FormField>
            )}
          </ConfigurableField>
          <ConfigurableField sectionId={S.contacts} fieldName="value" xs={12} sm={5} md={config ? 12 - md * 2 : 7}>
            {({ required }) => (
              <FormField label="Value" required={required} error={errors[`contacts.${i}.value`]}>
                <IpdTextField fullWidth size="small" placeholder="Value" value={c.value} onChange={(e) => updateListItem("contacts", i, "value", e.target.value)} error={Boolean(errors[`contacts.${i}.value`])} />
              </FormField>
            )}
          </ConfigurableField>
          {canRemoveListEntry(S.contacts, patient.contacts.length) && (
            <Grid item xs={12} sm={1}>
              <IconButton aria-label="Remove contact" onClick={() => removeListItem("contacts", i)}><DeleteIcon /></IconButton>
            </Grid>
          )}
        </Grid>
      ))}
      {canAddListEntry(S.contacts, patient.contacts.length) && (
        <Box display="flex" gap={1} flexWrap="wrap">
          <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={() => addListItem("contacts", { channel: "PHONE", type: "SECONDARY", value: "" })}>Phone</Button>
          <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={() => addListItem("contacts", { channel: "EMAIL", type: "PRIMARY", value: "" })}>Email</Button>
        </Box>
      )}
    </Box>
  );
}

export default memo(Contacts);
